import { useState, useEffect } from 'react'
import { fetchUserRecordings } from '../utils/recording'
import { Recording } from '../types'

export function useUserRecordings() {
  const [data, setData] = useState<Recording[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchUserRecordings()
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [])

  const refetch = () => {
    setIsLoading(true)
    setError(null)
    fetchUserRecordings()
      .then((channels) => {
        setData(channels)
        setError(null)
      })
      .catch((err) => setError(err as Error))
      .finally(() => setIsLoading(false))
  }

  return { data, setData, isLoading, error, refetch }
}
